module.exports = __webpack_public_path__ + "static/media/transmission-oil-temp.accb00bf.svg";